import { all } from "redux-saga/effects";
import loginSaga from "./LoginSaga";
import otpSaga from "./OtpSaga";
import { faqSaga, faqSectionSaga } from "./FAQSaga";
import registrationSaga from "./RegistrationSaga";
import logoutSaga from "./LogoutSaga";
import { shareTripSaga, tripSaga } from "./TripSaga";
import { autoCompleteSaga, directionSaga, geocodeSaga, nearBySearchSaga, placeDetailsSaga,locationCheckSaga } from "./GoogleMapSaga";
import { cancelReasonSaga, cancelTripSaga, rateCalculationSaga, refundPriceSaga, tripCheckoutSaga, tripSlabSaga, rentalSlabSaga } from "./CustomerTripSaga";
import { ProfileSaga, updateProfileSaga, verifyProfileSaga } from "./ProfileSaga";
import { paymentHashSaga, paymentMethodSaga, paymentVerifySaga } from "./PaymentSaga";
import { payuResponseSaga, payuSaga } from "./PayuSaga";
import { cashFreeSaga, cashfreeResponseSaga } from "./CashFreeSaga";
import { couponListSaga, applyCouponSaga, applyRentalCouponSaga } from "./CouponSaga";

export default function* rootSaga() {
  yield all([
    loginSaga(),
    otpSaga(),
    faqSaga(),
    faqSectionSaga(),
    registrationSaga(),
    logoutSaga(),
    tripSaga(),
    shareTripSaga(),
    placeDetailsSaga(),
    directionSaga(),
    autoCompleteSaga(),
    geocodeSaga(),
    rateCalculationSaga(),
    ProfileSaga(),
    updateProfileSaga(),
    tripCheckoutSaga(),
    paymentHashSaga(),
    paymentVerifySaga(),
    payuSaga(),
    nearBySearchSaga(),
    payuResponseSaga(),
    tripSlabSaga(),
    cancelTripSaga(),
    cancelReasonSaga(),
    refundPriceSaga(),
    rentalSlabSaga(),
    verifyProfileSaga(),
    cashFreeSaga(),
    cashfreeResponseSaga(),
    paymentMethodSaga(),
    couponListSaga(),
    applyCouponSaga(),
    applyRentalCouponSaga(),
    locationCheckSaga(),
  ]);
}
